import { ComponentStyleConfig } from '@chakra-ui/react';

export const Link: ComponentStyleConfig = {
    baseStyle: {
        fontWeight: 'semibold',
        color: 'green.500',
    },
};
